import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from 'components/layout';
import HomepageSlidersRoutes from './subPages/homepageSliders/routes';
import StaticPagesRoutes from './subPages/staticPages/routes';
// import RestaurantsRoutes from './subPages/restaurants/routes';
import PartnersRoutes from './subPages/partners/routes';
import ItinerariesRoutes from './subPages/itineraries/routes';
import ServicesRoutes from './subPages/services/routes';
import WebQrsRoutes from './subPages/webQrs/routes';
import HomepageBlocksRoutes from './subPages/homepageBlocks/routes';
import LandingPagesRoutes from './subPages/landingPages/routes';
import CarouselsRoutes from './subPages/carousels/routes';
import FooterMenusRoutes from './subPages/footerMenus/routes';

const WebsitePage = () => {
  return (
    <Layout>
      <Routes>
        <Route path='homepage_slides/*' element={<HomepageSlidersRoutes />} />
        <Route path='static_pages/*' element={<StaticPagesRoutes />} />
        {/* <Route path='restaurants/*' element={<RestaurantsRoutes />} /> */}
        <Route path='partners/*' element={<PartnersRoutes />} />
        <Route path='itineraries/*' element={<ItinerariesRoutes />} />
        <Route path='services/*' element={<ServicesRoutes />} />
        <Route path='web_qrs/*' element={<WebQrsRoutes />} />
        <Route path='homepage_blocks/*' element={<HomepageBlocksRoutes />} />
        <Route path='landing_pages/*' element={<LandingPagesRoutes />} />
        <Route path='carousels/*' element={<CarouselsRoutes />} />
        <Route path='footer_menus/*' element={<FooterMenusRoutes />} />
        <Route path='*' element={<Navigate to='homepage_slides' replace />} />
      </Routes>
    </Layout>
  );
};

export default WebsitePage;
